module.exports = ":host{display:flex;flex-direction:column}\n"